<template>
    <b-modal id="budgetNoteModal" 
        :title="$t('project.budgetNotes')" 
        hide-footer size="huge" 
        @hidden="clearForm();sysChange()" @shown="listBudgetNotes()">
        <b-form v-on:submit.prevent="createNote">
            <b-form-row class="mb-3">
                <b-col lg="12">
                    <h4>
                        {{ $t('hForm.Used') }}
                    </h4>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="dateUsed">{{ $t('hForm.dateUsed') }}</label>
                    <input type="date" required id="dateUsed" 
                        class="form-control" 
                        v-model="hForm.dateUsed">
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="budgetUsed">{{ $t('hForm.budgetUsed') }}</label>
                    <input type="number" required id="budgetUsed" 
                        class="form-control" 
                        v-model.number="hForm.budgetUsed">
                </b-col>
            </b-form-row>
            <b-form-row class="mb-3">
                <b-col lg="12">
                    <h4>
                        {{ $t('hForm.Planned') }}
                    </h4>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="datePlanned">{{ $t('hForm.datePlanned') }}</label>
                    <input type="date" required id="datePlanned" 
                        class="form-control" 
                        v-model="hForm.datePlanned">
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="budgetPlanned">{{ $t('hForm.budgetPlanned') }}</label>
                    <input type="number" required id="budgetPlanned" 
                        class="form-control" 
                        v-model.number="hForm.budgetPlanned">
                </b-col>
            </b-form-row>
            <b-form-row class="mb-3">
                <b-col lg="12">
                    <h4>
                        {{ $t('hForm.Current') }}
                    </h4>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="currentUsed">{{ $t('hForm.currentUsed') }}</label>
                    <input type="number" required id="currentUsed" 
                        class="form-control" 
                        v-model.number="hForm.currentUsed">
                </b-col>
                <b-col sm="auto" lg="6">
                    <div for="buddgetDiff" class="mt-3 text-right">{{ $t('hForm.budgetDiff') }}</div>
                    <div class="text-danger w-100 text-right">{{ hForm.budgetPlanned - hForm.currentUsed }}</div>
                </b-col>
            </b-form-row>
            <b-form-row class="mb-3">
                <b-col lg="12">
                    <h4 class="text-danger">
                        {{ $t('hForm.Warning') }}
                    </h4>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="budgetLack">{{ $t('hForm.budgetLack') }}</label>
                    <input type="number" required id="budgetLack" 
                        class="form-control" 
                        v-model.number="hForm.budgetLack">
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="warning">{{ $t('hForm.warning') }}</label>
                    <textarea required id="warning" 
                        class="form-control" 
                        v-model="hForm.warning"></textarea>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col lg="12">
                    <b-row class="pt-2">
                        <b-col lg="6">
                            <b-button size="sm" block variant="primary" @click="closeModal()" class="mr-2" >{{$t("hForm.back")}}</b-button>
                        </b-col>
                        <b-col lg="6">
                            <b-button size="sm" block variant="success" type="submit" >{{$t("hForm.addHistory")}}</b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-form-row>
        </b-form>

        <div class="w-100">
            <b-table striped hover :items="notes" 
                :fields="fields">

                <template v-slot:cell(actions)="data">
                    <b-button size="sm" variant="danger" 
                    @click="deleteHistory(data.item.id)">{{$t("hForm.delete")}}</b-button>
                </template>

            </b-table>
        </div>
    </b-modal>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader} from "@/config/config";
    import vue from 'vue';
    export default {
        name:"BudgetNotes",
        props:["pId"],
        data(){
            return {
                hForm:{
                    dateUsed:"",
                    budgetUsed:0,
                    datePlanned:"",
                    budgetPlanned:0,
                    currentUsed:0,
                    budgetLack:0,
                    warning:"",
                    pId:0
                },
                years:[],
                months:[],
                notes:[],
                fields:[
                    {
                        key:"dateUsed",
                        label: vue.i18n.translate('hForm.dateUsed'),
                    },

                    {
                        key: 'budgetUsed',
                        label: vue.i18n.translate('hForm.budgetUsed')
                    },
                    {
                        key: 'datePlanned',
                        label: vue.i18n.translate('hForm.datePlanned'),
                    },
                    {
                        key:"budgetPlanned",
                        label: vue.i18n.translate('hForm.budgetPlanned'),
                    },
                    {
                        key:"currentUsed",
                        label: vue.i18n.translate('hForm.currentUsed'),
                    },
                    {
                        key:"budgetLack",
                        label: vue.i18n.translate('hForm.budgetLack'),
                    },
                    {
                        key:"warning",
                        label: vue.i18n.translate('hForm.warning'),
                    },
                ]
            }
        },
        methods:{
            createNote(){
                alert("me is called i will do my job");
                if(this.pId==0){
                    alert("Project  not set");
                    return;
                }
                this.hForm.pId=this.pId;
                axios.post(apiDomain+"/p/budget/create",this.hForm,{headers:getHeader()})
                .then(response=>{
                    this.clearForm();
                    this.listBudgetNotes();
                    
                }).catch(error=>{
                    console.log(error);
                });
            },
            listBudgetNotes(){
                axios.post(apiDomain+"/p/budget/list",{pId:this.pId},{headers:getHeader()})
                .then(response=>{
                    //alert(JSON.stringify(this.notes));
                    this.notes=response.data;
                }).catch(error=>{
                    console.log(error);
                });
            },
            createHistory(){
                alert(JSON.stringify(this.hForm));
            },
            closeModal(){
                this.clearForm();
                this.$bvModal.hide("historyModal");

            },
            setDates(){
                let currentYear=new Date().getFullYear();
                for(let year = 2000;year<=currentYear;year++){
                    this.years.push(year);
                }
                for(let month=1;month<=12;month++){
                    this.months.push(month);
                }
            },
            clearForm(){
                this.hForm={
                    dateUsed:"",
                    budgetUsed:0,
                    datePlanned:"",
                    budgetPlanned:0,
                    currentUsed:0,
                    budgetLack:0,
                    warning:"",
                    pId:0
                };
            },
            sysChange(){}
        },
        created(){
            this.setDates();
            //this.listBudgetNotes()
        }
    }
</script>